import React from 'react';
import { Box } from '@material-ui/core';
import { InfoItem } from '../../../InfoItem/UserInfoField';
import { formatDetailValue } from '../../formatDetailValue';

export const DIAM_DETAILS_FIELD_GAP = 24;

interface DiamDetailsFieldsProps {
  children: React.ReactNode;
}

export function DiamDetailsFields({ children }: DiamDetailsFieldsProps) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      style={{ gap: DIAM_DETAILS_FIELD_GAP }}
    >
      {children}
    </Box>
  );
}

interface DiamDetailsTextFieldProps {
  title: string;
  value?: string | null;
}

export function DiamDetailsTextField({
  title,
  value,
}: DiamDetailsTextFieldProps) {
  return <InfoItem title={title} value={formatDetailValue(value)} />;
}
